/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import axiosIntegration from "../../Common/Axios/axiosIntegration";
import axiosInstanceClient from "../../Common/Axios/axiosInstanceClient";
import axiosInstance from "../../Common/Axios/axiosInstance";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import {
  ApiRespCode,
  ClientInfo,
  Dispatch,
  EarnPoint,
  GenerateToken,
  GetMemberData,
  LoginV3Data,
  MaxQuan,
  OrderData,
  ParseInt,
  SendSms,
  showMaxMessg,
  V3Data,
  VendorData,
  Navigate,
  RedeemPoint,
  ClientConfigurationData,
  handleError,
  SendMail,
  cleanHTML,
  EmailData,
  trackEvent,
  formatPrice,
  CardDataSlice,
  dynamicSuccessEmailColumnChnages,
  getImageUrl,
} from "../Utility/Utility";
import {
  onPostOrder,
  onPostOrderReset,
  onUpdateOrder,
  onUpdateOrderReset,
  onUpdateOrderSuccessReset,
  onPendingOrderReset,
} from "../../Store/Slices/orderSlice";
import { onPostEarnPointReset } from "../../Store/Slices/earnPointSlice";
import { onPostVendorOrderReset } from "../../Store/Slices/vendorOrderSlice";
import { onGenerateTokenSubmitReset } from "../../Store/Slices/generateTokenSlice";

import {
  callSwitchAccountApi,
  handleEarnPoints,
  handleGenerateToken,
  handleGetMember,
  handlePointsUpdate,
  handleProcessingSms,
  handleRedeem,
  handleVedorOrder,
} from "../OrderUtility/OrderUitlity";

import { onGetMemberReset } from "../../Store/Slices/getMemberSlice";
import {
  onAllSmsSentSuccess,
  onPostSendSmsReset,
  onPostSendSmsSubmit,
} from "../../Store/Slices/sendSmsSlice";
import {
  onSaveDenoCardReset,
  onSaveOrderData,
  onSavePoints,
  onShowFailure,
  onShowFailureReset,
  onShowThankYou,
} from "../../Store/Slices/cardDataSlice";
import { onPostRedeemPointsReset } from "../../Store/Slices/redeemPointsSlice";
import {
  decryptAES,
  encryptAES,
  encryptURLParam,
} from "../../Common/Axios/encrypt";
import API from "../../Common/Endpoint/serviceConstrants";
import {
  onPostSendMail,
  onPostSendMailReset,
} from "../../Store/Slices/sendMailSlice";
import { useSelector } from "react-redux";
import { onPostSwitchAccountReset } from "../../Store/Slices/switchAccountSlice";

const UserDetails = ({
  totalPayableAmount,
  productData,
  productReducer,
  quantities,
  updatedData,
  burnPoints,
  earnPoints,
  cash,
  points,
  setLoading,
  razorPayKey,
  setPoints,
  setBurnPoints,
  convenienceFee,
  gst,
  setTotalPayableAmount,
  currentBalance,
  setOrderJourneyStarted,
  disabled,
}) => {
  const isUserAccrodianCollapsed = useSelector(
    (state) =>
      state.clientConfigurationReducer?.clientConfigurationData[0]
        ?.enableCollapsibleUserInfo,
  );
  const genrateTokenApiDetails = useSelector(
    (state) => state.generateTokenSliceReducer.isError,
  );
  useEffect(() => {
    if (genrateTokenApiDetails) {
      if (generateToken?.status_code === 400 && onlyCash) {
        navigate("/order-confirmation");
        dispatch(onGenerateTokenSubmitReset());
        dispatch(onPostSendMailReset());
        dispatch(onPostSendSmsReset());
        return;
      }
    }
  }, [genrateTokenApiDetails]);

  const clientInfo = ClientInfo();
  const clientConfig = ClientConfigurationData();
  const dispatch = Dispatch();
  const earnMinDeno = productData?.minEarnPoints;
  const burmMinDeno = productData?.maxEarnPoints;
  const v3Data = V3Data();
  const orderData = OrderData();
  const redeemPoint = RedeemPoint();
  const vendorData = VendorData();
  const generateToken = GenerateToken();
  const loginV3Data = LoginV3Data();
  const sendMailData = SendMail();
  const maxQuan = MaxQuan();
  const sendSms = SendSms();
  const memberData = GetMemberData();
  const loginToken = LoginV3Data();
  const navigate = Navigate();
  const translation = getTranslationData();
  const [openInst, setOpenInst] = useState(false);
  const [openRedeem, setOpenRedeem] = useState(false);
  const [openTermsCon, setOpenTermsCon] = useState(false);
  const [forward, setForward] = useState(false);
  const [openNote, setOpenNote] = useState(false);
  const [redeemFail, setredeemFail] = useState(null);
  const emailData = EmailData();
  const earnPointData = EarnPoint();
  const cardData = CardDataSlice();
  const loginTokenData = loginToken?.memberProfile;
  const [openUser, setOpenUser] = useState(false);
  const [productSupplierMargin, setProductSupplierMargin] = useState([]);
  const matchedSupplierMargins = productSupplierMargin.filter(
    (item) => item.productId === productReducer?.productReducer?.id,
  );
  const switchAccountReducer = useSelector(
    (state) => state.switchAccountReducer,
  );
  const totalPaid = Number(
    updatedData?.reduce(
      (acc, card) => acc + (card?.you_pay || 0) * (card?.quantity || 0),
      0,
    ) +
    (convenienceFee || 0) +
    (gst || 0),
  );
  const member = sessionStorage.getItem("member");
  const onlyCash = totalPayableAmount > 0 && burnPoints === 0;
  const cashPlusPoints = totalPayableAmount > 0 && burnPoints > 0;
  const flow2 = clientInfo?.otpConfig === 2;
  const flow1 = clientInfo?.otpConfig === 1;
  const supplierMargin = matchedSupplierMargins?.[0]?.supplierMargin;
  const clientConfigurations = clientInfo?.clientData?.clientConfigurations;
  const isEarn = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isearn",
  )?.configValue;
  const isBurn = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isburn",
  )?.configValue;
  const isEarnView = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isearnview",
  )?.configValue;
  const paymentConfig = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "checkout_display_config"
  )?.configValue;
  const vendorApiFail = useSelector(
    (state) => state.cardDataSliceReducer?.failure,
  );
  const cardListData = useSelector((state) => state.clientConfigDataReducer);
  const categoryData = useSelector(
    (state) => state.userRoleSliceReducer.categoryData,
  );

  // const categoryAllData = Array.isArray(categoryData) && categoryData;
  const category =
    categoryData?.find(
      (findData) => findData?.id === productReducer?.productReducer?.categoryId,
    )?.name || "";
  const commissionClient = productData?.clientCommission || "";

  const clientCommissionData =
    commissionClient === null ||
      commissionClient === undefined ||
      commissionClient === "" ||
      !commissionClient
      ? 0
      : commissionClient;

  const razorPayPayment = () => {
    setLoading(true);
    sessionStorage.setItem("payment", true)
    const options = {
      key: decryptAES(orderData?.postOrderData?.[0]?.apiKey),
      amount: totalPayableAmount.toFixed(2) * 100,
      order_id: orderData?.postOrderData?.[0]?.razorPayOrderId,
      currency: "INR",
      prefill: {
        name: loginV3Data?.memberProfile?.firstName,
        email: loginV3Data?.memberProfile?.emailId,
        contact: loginV3Data?.memberProfile?.mobileNumber,
      },
      ...(paymentConfig ? { config: JSON.parse(paymentConfig) } : {}),
      handler: function (response) {
        sessionStorage.setItem("payment", false)
        if (response?.razorpay_payment_id) {
          setLoading(false);
          if (burnPoints > 0) {
            handleUpatdeOrder(response, true, true);
          } else {
            handleUpatdeOrder(response, true);
          }
        }
      },
      modal: {
        ondismiss: function () {
          sessionStorage.setItem("payment", false)
          handleUpatdeOrder(
            undefined,
            false,
            false,
            false,
            true,
            false,
            "Cancelled",
          );
          // handleUpatdeOrder(undefined, false, false, false);
          setLoading(false);
          handleSet();
        },
      },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open();
    rzp1.on("payment.failed", function (response) {
      // only update order status
      sessionStorage.setItem("payment", false)
      handleUpatdeOrder(
        undefined,
        false,
        false,
        false,
        false,
        true,
        "",
        response,
      );
      setLoading(false);
    });
  }

  const payuPayment = () => {
    if (!window.bolt) {
      console.error("PayU Bolt not loaded");
      return;
    }
    const userIdentifier =
    loginV3Data?.memberProfile?.mobileNumber ||
    loginV3Data?.memberProfile?.emailId;
    sessionStorage.setItem("payment", true)
    const data = {
      key: decryptAES(orderData?.postOrderData?.[0]?.apiKey),
      txnid: orderData?.postOrderData?.[0]?.orderId,
      hash: orderData?.postOrderData?.[0]?.razorPayOrderId,
      amount: totalPayableAmount.toFixed(2),
      firstname: `${loginV3Data?.memberProfile?.firstName || ""} ${loginV3Data?.memberProfile?.lastName || ""}`.trim(),
      email: loginV3Data?.memberProfile?.emailId,
      phone: loginV3Data?.memberProfile?.mobileNumber,
      productinfo: productReducer?.productReducer?.sku,
      store_card: 1,
      user_credentials: `${decryptAES(orderData?.postOrderData?.[0]?.apiKey)}:${userIdentifier}`,
      offer_key: orderData?.postOrderData?.[0]?.offerId,
      surl: "https://thirdparty.com/testresponse.php",
      furl: "https://thirdparty.com/testresponse.php"

    };

    const handlers = {
      responseHandler: function (BOLT) {
        sessionStorage.setItem("payment", false)
        if (BOLT.response.txnStatus === "SUCCESS") {
          console.log("Payment success", BOLT.response);
          setLoading(false);
          if (burnPoints > 0) {
            handleUpatdeOrder(BOLT.response, true, true);
          } else {
            handleUpatdeOrder(BOLT.response, true);
          }
        } else {
          handleUpatdeOrder(
            undefined,
            false,
            false,
            false,
            true,
            false,
            "Cancelled",
          );
          // handleUpatdeOrder(undefined, false, false, false);
          setLoading(false);
          handleSet();
        }
      },
      catchException: function (err) {
        sessionStorage.setItem("payment", true)
        console.log("Payment failed. Please try again.", err);
        handleUpatdeOrder(
          undefined,
          false,
          false,
          false,
          false,
          true,
          "",
          err,
        );
        setLoading(false);
      }
    };

    window.bolt.launch(data, handlers);
  };


  const handlePayment = () => {
    
    sessionStorage.removeItem("payment");
    if (process.env.REACT_APP_IS_SKIP_PAYMENT_GATEWAY === "true") {
      const ress = {
        razorpay_payment_id: orderData?.postOrderData?.[0]?.razorPayOrderId,
        razorpay_order_id: orderData?.postOrderData?.[0]?.razorPayOrderId,
        razorpay_signature: orderData?.postOrderData?.[0]?.razorPayOrderId,
      };
      handleUpatdeOrder(ress, true);
    } else if (orderData?.postOrderData?.[0]?.paymentPartner === "PAYU") {
      payuPayment();
    }
    else if (orderData?.postOrderData?.[0]?.paymentPartner === "RAZORPAY") {
      razorPayPayment();
    }
  };
  const calculateConvenienceFeeGst = (
    denom,
    totalPaid,
    convenienceFee,
    gst,
  ) => {
    const perPointValue = denom / (totalPaid - (convenienceFee + gst));
    const denomWiseConvFee = +(convenienceFee * perPointValue);
    const denomWiseGst = +(gst * perPointValue);
    return denom + denomWiseConvFee + denomWiseGst;
  };

  const calculateEarnPoints = (dino_net_sale, net_sale, burn_or_earn) => {
    let bunrEarn = burn_or_earn;
    if (typeof burn_or_earn === "string") {
      bunrEarn = parseInt(bunrEarn.replace(/,/g, ""));
    }
    const result = (dino_net_sale / net_sale) * bunrEarn;
    return Math.round(result * 100) / 100; // returns a number
  };

  const allZero = (arr) => {
    return arr.every((value) => value === 0);
  };
  const handleSet = () => {
    sessionStorage.setItem("member", true);
    if (currentBalance !== 0 && burnPoints > 0) {
      // handleGetMember(dispatch, loginV3Data, v3Data);
      callSwitchAccountApi(dispatch, loginToken, v3Data);
    }
    if (burnPoints === 0) {
      //toast.error(translation.order_cancelled_by_customer_msg);
    }
    setPoints(0);
    setBurnPoints(0);
    setTotalPayableAmount(cash - convenienceFee - gst);
  };

  useEffect(() => {
    const cached = sessionStorage.getItem("supplier_margin");
    if (cached) {
      setProductSupplierMargin(JSON.parse(cached));
      return;
    }

    const fetchSupplierMargin = async () => {
      const res = await axiosInstance.get(API.supplier_margin);
      if (res?.data?.response) {
        sessionStorage.setItem(
          "supplier_margin",
          JSON.stringify(res.data.response),
        );
        setProductSupplierMargin(res.data.response);
      }
    };
    fetchSupplierMargin();
  }, []);

  const productList =
    productReducer?.modalProductData ?? productReducer?.arrayData?.arrayData;
  let OrderPayload = {
    memberId: loginV3Data?.memberIdentifier,
    amount: totalPayableAmount === 0 ? 0 : totalPayableAmount,
    totalEarn: onlyCash ? (isEarnView === 2 ? 0 : ParseInt(earnPoints)) : 0,
    totalBurn: !onlyCash ? burnPoints : 0,
    totalSupplierMargin: supplierMargin,
    totalClientCommission: clientCommissionData,
    totalAmount: parseFloat(totalPaid.toFixed(2)),
    category: category,
    supplierCode: "",
    orderStatus: "Pending",
    pointsRedeemStatus: burnPoints === 0 ? "NA" : "Pending",
    pointsEarnStatus: onlyCash ? "Pending" : "NA",
    pointReversalStatus: "NA",
    pointEarnReversalStatus: "NA",
    paymentStatus: onlyCash || cashPlusPoints ? "Pending" : "NA",
    mobile: loginV3Data?.memberProfile?.mobileNumber,
    email: loginV3Data?.memberProfile?.emailId,
    convenienceFee: parseFloat(convenienceFee) || 0,
    gst: gst || 0,
    amountWithoutGst: parseFloat((totalPaid - convenienceFee - gst).toFixed(2)),
    userPaymentMode: onlyCash
      ? "Cash"
      : cashPlusPoints
        ? "Cash + Points"
        : "Only Points",
    customerName:`${
  loginV3Data?.memberProfile?.firstName || ""
} ${
  loginV3Data?.memberProfile?.lastName || ""
}`.trim(),
    products:
      Array.isArray(productList) &&
      updatedData.map((item) => ({
        productId: productReducer?.productReducer?.id,
        sku: productReducer?.productReducer?.sku,
        denomination: item.denomination,
        qty: item.quantity,
        customerDis: productReducer?.productReducerDisocount?.customerDiscount,
        clientCommission: clientCommissionData,
        supplierMargin: supplierMargin,
        earnPoint: onlyCash
          ? earnMinDeno
            ? isEarnView === 2
              ? 0
              : calculateEarnPoints(
                calculateConvenienceFeeGst(
                  parseFloat(item.total),
                  totalPaid,
                  convenienceFee,
                  gst,
                ),
                totalPaid,
                earnPoints,
              )
            : 0
          : 0,
        burnPoint: !onlyCash
          ? burmMinDeno
            ? calculateEarnPoints(
              calculateConvenienceFeeGst(
                parseFloat(item.total),
                totalPaid,
                convenienceFee,
                gst,
              ),
              totalPaid,
              burnPoints,
            )
            : 0
          : 0,
        image: productReducer?.productReducer?.small,
        name: productReducer?.productReducer?.name,
      })),
  };
  const handleOrder = async () => {
    sessionStorage.removeItem("OrderPayloadSession");
    sessionStorage.removeItem("burn");
    dispatch(onPostOrder(OrderPayload));
  };

  const manageUrl = async () => {
    setLoading(true);
    try {
      const responses = await Promise.allSettled(
        productList.map(async (prod) => {
          const enc = encryptAES(
            `email=true&orderId=${orderData?.postOrderData?.[0]?.orderid}&denomination=${prod.denomination}&memberId=${memberData?.MemberData?.memberProfile?.pointBalance}`,
          );

          const longUrl = `${window.location.origin}/${clientConfig?.otpRedeem ? "otp" : "order-detail"
            }?${enc}`;

          const payload = {
            longUrl,
            otp: enc,
            orderId: orderData?.postOrderData?.[0]?.orderNumber,
            denomination: prod.denomination,
          };

          const response = await axiosInstanceClient.post(
            API.manageUrl,
            payload,
          );

          return {
            ...prod,
            shortUrl: response.data?.response?.[0]?.shortUrl || longUrl,
            fallbackUrl: longUrl,
          };
        }),
      );

      const activesms = getSMSTemplateByType("Success");
      const giftCode = vendorData?.vendorOrderData?.giftcode
        ? decryptAES(vendorData?.vendorOrderData?.giftcode)
        : null;

      for (var i = 0; i < giftCode.length; i++) {
        var dynamicdata = activesms.smsBody;
        // dynamicdata = dynamicdata.replace(
        //   "{#var1#}",
        //   OrderPayload?.products?.[0]?.name
        // );
        dynamicdata = dynamicdata.replace(
          "{%memberName%}",
          OrderPayload?.customerName,
        );
        dynamicdata = dynamicdata.replace(
          "{%orderId%}",
          orderData?.postOrderData?.[0]?.orderId,
        );
        dynamicdata = dynamicdata.replace(
          "{%voucherName%}",
          OrderPayload?.products?.[0]?.name,
        );
        dynamicdata = dynamicdata.replace(
          "{%voucherValue%}",
          formatPrice(giftCode?.[i]?.Amount),
        );

        dynamicdata = dynamicdata?.replace(
          "{%voucherDate%}",
          new Date(giftCode?.[i]?.Validity)
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
            .replace(/ /g, " "),
        );
        var namel = giftCode[i]?.labels?.cardPin;

        var numberL = giftCode[i]?.labels?.cardNumber;
        const cardNumber = giftCode[i]?.CardNumber
          ? `\n${numberL} ${giftCode[i].CardNumber}`
          : "";
        const cardPin = giftCode[i]?.CardPin
          ? `\n${namel} ${giftCode[i].CardPin}`
          : "";

        dynamicdata = dynamicdata.replace("{%voucherPin%}", cardPin || "");
        dynamicdata = dynamicdata.replace("{%voucherCode%}", cardNumber || "");

        const payload = {
          ClientCode: v3Data?.ClientCode,
          partnerCode: v3Data?.partnerCode,
          templateCode: activesms?.tempCode,
          toMobileNumber: loginV3Data?.memberProfile?.mobileNumber,
          contentValue: {
            additionalProp1: "string",
          },
          content: dynamicdata,
        };

        dispatch(onPostSendSmsSubmit(payload));
      }
      responses.forEach((result, index) => {
        const prod = productList[index];
        const enc = encryptAES(
          `email=true&orderId=${orderData?.postOrderData?.[0]?.orderId}&denomination=${prod.denomination}&memberId=${memberData?.MemberData?.memberProfile?.pointBalance}`,
        );

        const longUrl = `${window.location.origin}/${clientConfig?.otpRedeem ? "otp" : "order-detail"
          }?${enc}`;
        const url =
          result.status === "fulfilled"
            ? result.value.shortUrl || longUrl
            : longUrl;
      });
    } catch (error) {
      console.error("Unexpected error during manageUrl execution:", error);
    } finally {
      dispatch(onAllSmsSentSuccess());
      navigate("/order-confirmation");
      dispatch(onPostSendMailReset());
      dispatch(onPostSendSmsReset());
    }
  };

  const handleUpatdeOrder = async (
    transaction,
    paymentVerify = false,
    pointReddemed = false,
    pointEarn = false,
    orderCancelled = false,
    orderFailed = false,
    pointEarnPaymentStatus,
    paymentFailedStatus,
  ) => {
    // Check if a payload already exists in sessionStorage
    const existingPayload = sessionStorage.getItem("OrderPayloadSession");
    let payload;

    if (existingPayload) {
      // Parse and use the existing payload
      payload = JSON.parse(existingPayload);
      // Remove paymentStatus if it exists
      if (payload.hasOwnProperty("paymentStatus")) {
        delete payload.paymentStatus;
        delete payload.orderStatus;
      }
    } else {
      payload = OrderPayload;
    }
    // Build new payload
    payload = {
      ...payload,
      ...(pointReddemed && {
        pointsRedeemStatus: pointReddemed ? "Completed" : "failed",
      }),
      ...(pointEarn && {
        pointsEarnStatus: "Completed",
        paymentStatus: pointEarnPaymentStatus,
      }),
      ...(paymentVerify && {
        paymentVerify: [
          {
            ...transaction,
            paymentId: transaction?.razorpay_payment_id,
            orderid: transaction?.razorpay_order_id,
            signature: transaction?.razorpay_signature,
          },
        ],
        // paymentStatus: "Completed",
        // orderStatus: "Completed",
      }),
      ...(orderCancelled && {
        paymentStatus: "Cancelled",
        orderStatus: "Cancelled",
      }),
      ...(orderFailed && {
        paymentStatus: "Failed",
        orderStatus: "Failed",
        paymentErrorLog: JSON.stringify(paymentFailedStatus?.error),
      }),
      id: orderData?.postOrderData?.[0]?.id,
      ...(flow2 && totalPayableAmount === 0 && { orderStatus: "Completed" }),
    };

    // Save to sessionStorage
    sessionStorage.setItem("OrderPayloadSession", JSON.stringify(payload));

    // Update OrderPayload (optional, in case other code depends on it)
    OrderPayload = payload;

    // Dispatch the update
    await dispatch(onUpdateOrder(payload));
  };

  const products =
    Array.isArray(productList) &&
    updatedData.map((item) => ({
      sku: productReducer?.productReducer?.sku,
      denomination: item.denomination,
      qty: item.quantity,
    }));

  const totalAmount =
    products &&
    products?.reduce((sum, item) => sum + item.denomination * item.qty, 0);
  const vendorPayload = {
    orderId: orderData?.postOrderData?.[0]?.orderNumber,
    internalOrderId: orderData?.postOrderData?.[0]?.orderId,
    amount: parseInt(totalAmount),
    supplierCode: productReducer?.productReducer?.vendorOrganization,
    products: products,
  };

  useEffect(() => {
    const orderCreated = orderData?.post_status_code === ApiRespCode.create;
    const orderCreateResp = orderData?.post_status_code;
    const orderUpdated =
      orderData?.updatedOrderData?.paymentStatus === "Cancelled" ||
        orderData?.updatedOrderData?.paymentStatus === "Failed" ||
        orderData?.updatedOrderData?.paymentStatus === "Pending"
        ? false
        : orderData?.update_status_code === ApiRespCode.create;
    const orderUpdatedResp = orderData?.update_status_code;
    const updatedOrderData = orderData?.updatedOrderData;
    const pointsRedeemed =
      redeemPoint?.post_status_code === ApiRespCode.v3Success;

    const vendorCreated = vendorData?.post_status_code === ApiRespCode.create;
    const vendorProcessing =
      vendorData?.post_status_code === ApiRespCode.v3Success;

    const vendorFailed =
      vendorData?.post_status_code && !vendorCreated && !vendorProcessing;
    const tokenCreated = generateToken?.status_code === ApiRespCode.v3Create;
    const earnPointSuccess =
      earnPointData?.status_code === ApiRespCode.v3Success;
    const memberFetched =
      switchAccountReducer?.post_status_code === ApiRespCode.v3Success;
    const mailSent = sendMailData?.post_status_code;
    if (orderCreated) {
      sessionStorage.removeItem("earn");
      sessionStorage.removeItem("member");
      if (totalPayableAmount > 0 && burnPoints === 0) {
        handlePayment();
      } else if (
        v3Data?.accessKey &&
        v3Data?.secrateKey &&
        v3Data?.partnerCode &&
        v3Data?.ClientCode
      ) {
        handleGenerateToken(dispatch, v3Data);
      }

      const orderDetails = {
        tncContent: productReducer?.productReducerDisocount?.tncContent,
        totalPayableAmount,
        burnPoints: burnPoints,
        orderId: orderData?.postOrderData?.[0]?.orderId,
        name: productReducer?.productReducerDisocount?.name,
        id: productReducer?.productReducerDisocount?.id,
        quantity: productReducer?.arrayData?.arrayData?.[0]?.quantity,
        orderItems: updatedData,
        earnPoints: earnPoints,
        cardName: productReducer?.productReducerDisocount?.name,
        cardImage: productReducer?.productReducerDisocount?.small,
      };

      dispatch(onSaveOrderData(orderDetails));
      dispatch(onPostOrderReset());
      return;
    } else if (orderCreateResp) {
      handleError(
        "Oops! We couldn't place your order right now. Please try again in a few moments.",
      );
      dispatch(onPostOrderReset());
    }

    if (
      orderUpdated &&
      !member &&
      !sessionStorage.getItem("earn") &&
      totalPayableAmount > 0
    ) {
      if (flow1) {
        if (burnPoints > 0) {
          if (!redeemFail) {
            handleVedorOrder(dispatch, vendorPayload);
          }
        }
        if (burnPoints === 0) {
          handleVedorOrder(dispatch, vendorPayload);
        }
      } else if (totalPayableAmount > 0 && burnPoints > 0 && flow2) {
        // handleGetMember(dispatch, loginV3Data, v3Data);
        callSwitchAccountApi(dispatch, loginToken, v3Data);
      } else if (flow2) {
        handleGenerateToken(dispatch, v3Data);
      }
      dispatch(onUpdateOrderReset());
      return;
    } else if (orderUpdatedResp && member) {
      handleError(translation.order_cancelled_by_customer_msg,
        10000
      );
      dispatch(onUpdateOrderReset());
    }

    // const paymentAttempted =
    //   orderData?.updatedOrderData?.paymentStatus === "Pending";

    // if (
    //   paymentAttempted &&
    //   (orderData?.update_status_code === 400 ||
    //     orderData?.update_status_code === "400")
    // ) {
    //   navigate("/processign-payment");
    //   dispatch(onUpdateOrderReset());
    //   return;
    // }

    if (pointsRedeemed) {
      setredeemFail(false);
      handleUpatdeOrder(
        undefined,
        false,
        true,
        false,
        false,
        false,
        updatedOrderData?.paymentStatus,
      );
      if (
        totalPayableAmount === 0 &&
        flow1 &&
        !sessionStorage.getItem("burn")
      ) {
        sessionStorage.setItem("burn", true);
        handleVedorOrder(dispatch, vendorPayload);
      } else if (totalPayableAmount === 0 && flow2) {
        // handleGetMember(dispatch, loginV3Data, v3Data);
        callSwitchAccountApi(dispatch, loginToken, v3Data);
      } else {
        handlePayment();
      }
      dispatch(onPostRedeemPointsReset());
      return;
    }
    if (!pointsRedeemed && redeemPoint?.post_status_code !== null) {
      setredeemFail(true);
      dispatch(onPostRedeemPointsReset());
      setPoints(0);
      setBurnPoints(0);
      setTotalPayableAmount(cash - convenienceFee - gst);
      handleUpatdeOrder(undefined, false, false, false, false, false, "");
    }
    if (vendorCreated || vendorProcessing) {
      if (totalPayableAmount > 0 && burnPoints === 0) {
        handleGenerateToken(dispatch, v3Data);
      } else {
        
        // handleGetMember(dispatch, loginV3Data, v3Data);
        callSwitchAccountApi(dispatch, loginToken, v3Data);
      }
      dispatch(onShowFailureReset());
      dispatch(onPostVendorOrderReset());
      return;
    }

    if (vendorFailed) {
      dispatch(onShowFailure());
      dispatch(onPostVendorOrderReset());
      dispatch(onPostRedeemPointsReset());
      dispatch(onGenerateTokenSubmitReset());
      dispatch(onPostEarnPointReset());
      dispatch(onPostSendSmsReset());
      if (burnPoints > 0) {
        callSwitchAccountApi(dispatch, loginToken, v3Data);
        return;
      }
      // If no points used, just go
      navigate("/order-confirmation", {
        state: vendorData,
      });

      dispatch(onPostSendMailReset());
      dispatch(onPostSendSmsReset());
      return;
    }

    if (tokenCreated) {
      if (
        clientConfigurations?.length
          ? totalPayableAmount > 0 &&
          burnPoints === 0 &&
          ParseInt(earnPoints) > 0 &&
          isEarn !== 2 &&
          isBurn !== 2
          : totalPayableAmount > 0 &&
          burnPoints === 0 &&
          ParseInt(earnPoints) > 0
      ) {
        sessionStorage.setItem("earn", true);

        handleEarnPoints(
          dispatch,
          loginV3Data,
          v3Data,
          productReducer,
          orderData,
          totalPaid,
          earnPoints,
          totalQuantity,
          generateToken,
          axiosIntegration,
        );
      } else if (burnPoints > 0) {
        handleRedeem(
          dispatch,
          v3Data,
          loginV3Data,
          burnPoints,
          orderData?.postOrderData?.[0]?.orderId,
          axiosIntegration,
          generateToken,
          totalPayableAmount,
          onlyCash,
          cashPlusPoints,
          totalPaid,
          category,
          productReducer?.productReducer?.sku
        );
      } else {
        setForward(true);
      }
      dispatch(onGenerateTokenSubmitReset());
      return;
    }

    if (earnPointSuccess) {
      handleUpatdeOrder(
        undefined,
        false,
        false,
        true,
        false,
        false,
        updatedOrderData?.paymentStatus,
      );
      // handleGetMember(dispatch, loginV3Data, v3Data);
      callSwitchAccountApi(dispatch, loginToken, v3Data);
      dispatch(onPostEarnPointReset());
      return;
    }
    if (!earnPointSuccess && earnPointData?.status_code !== null) {
      dispatch(onPostEarnPointReset());
      navigate("/order-confirmation");
      dispatch(onPostSendMailReset());
      dispatch(onPostSendSmsReset());
      return;
    }
    if (cardData?.failure && memberFetched && !member) {
      debugger
      handlePointsUpdate(
        dispatch,
        switchAccountReducer?.switchAccountData?.memberBalance,
      );
      dispatch(onUpdateOrderReset());
      dispatch(onPostSwitchAccountReset());
      dispatch(onGetMemberReset());
      navigate("/order-confirmation", {
        state: vendorData,
      });
      dispatch(onPostSendMailReset());
      dispatch(onPostSendSmsReset());
      return;
    }
    
    if (memberFetched && !member) {
      debugger
      handlePointsUpdate(
        dispatch,
        switchAccountReducer?.switchAccountData?.memberBalance,
      );
      dispatch(onUpdateOrderReset());
      dispatch(onPostSwitchAccountReset());
      sendMail();
      dispatch(onGetMemberReset());
      return;
    }
    
    if (forward) {
      sendMail();
    }
    if (memberFetched && member) {
      debugger
      handlePointsUpdate(
        dispatch,
        switchAccountReducer?.switchAccountData?.memberBalance,
      );
      //toast.error(translation.order_cancelled_by_customer_msg);
      dispatch(onGetMemberReset());
      dispatch(onPostSwitchAccountReset());
      return;
    }
    if (mailSent) {
      setForward(false);
      if (
        vendorData?.postMessage?.toLowerCase() === "Processing".toLowerCase()
      ) {
        sessionStorage.removeItem("member");
        dispatch(onPostSendMailReset());
        dispatch(onPostSendSmsReset());
        // dispatch(onUpdateOrderSuccessReset());
        navigate("/order-ConfirmationAlternate", {
          state: { orderDetails: true },
        });
      } else {
        if (!vendorApiFail) {
          manageUrl();
        }
        sessionStorage.removeItem("member");
        dispatch(onPostSendMailReset());
        dispatch(onPostSendSmsReset());
        // dispatch(onUpdateOrderSuccessReset());
      }
    }
    if (orderData?.updatedOrderData?.paymentStatus === "Pending" && sessionStorage.getItem("payment") === 'false') {
      dispatch(onPendingOrderReset());
      navigate("/processign-payment");
    }
    // navigate ONLY after order update API confirms FAILED status
    if (
      orderData?.update_status_code === ApiRespCode.create &&
      orderData?.updatedOrderData?.paymentStatus === "Failed"
    ) {
      dispatch(onUpdateOrderReset());
      navigate("/payment-failed", { state: productReducer });
      window.location.reload();
    }
  }, [
    orderData,
    vendorData,
    generateToken,
    earnPointData,
    sendMailData,
    memberData,
    redeemPoint,
    v3Data,
    setForward,
    forward,
    switchAccountReducer,
  ]);

  useEffect(() => {
    onSaveDenoCardReset();
  }, []);

  const totalQuantity = (quantities ?? []).reduce(
    (sum, value) => sum + value,
    0,
  );
  const handleSubmit = () => {
    const memberId = loginV3Data?.memberIdentifier;

    if (!memberId) {
      toast.error(translation?.ReLoginAtCheckoutPage);
      return;
    }
    dispatch(onShowFailureReset());
    dispatch(onShowThankYou());
    if (maxQuan > 0 && totalQuantity > maxQuan) {
      showMaxMessg(translation.max_limit_allowed, maxQuan);
      return;
    } else if (allZero(quantities)) {
      toast.error(translation?.pleaseAddSomeProductsQuantitys);
    } else {
      handleOrder();
    }
    let basePayableAmount = 0;
    let totalDenomination = 0;
    updatedData?.forEach((item) => {
      const qty = item.quantity || 0;
      totalDenomination += item.denomination * qty;
      basePayableAmount += item.you_pay * qty;
    });
    const totalDiscount = totalDenomination - basePayableAmount;
    const selectedCard = localStorage.getItem("RewardWidget");
    const cardData = cardListData?.clientConfigData?.cards?.find(
      (card) => card.cardId === selectedCard,
    );
    let rewardPoints = 0;
    if (cardData) {
      rewardPoints = Math.floor(
        (totalPayableAmount / cardData.perRs) *
        cardData.standardPoints *
        (cardData.bonusPoints / cardData.standardPoints + 1),
      );
    }

    trackEvent("add_payment_info", {
      currency: "INR",
      value: totalPayableAmount,
      convenience_fee: convenienceFee,
      total_gift_card_points: (OrderPayload?.products || []).reduce(
        (sum, p) => sum + Number(p?.denomination || 0) * Number(p?.qty || 0),
        0,
      ),
      //burn_point: burnPoints,
      card_name: selectedCard,
      reward_points: rewardPoints,
      // card_id: productReducer?.productReducerDisocount?.sku,
      //  quantity: totalQuantity,
      discount: totalDiscount,
      // burn_point: OrderPayload?.totalBurn,
      items: OrderPayload?.products?.map((item) => {
        const denom = Number(item?.denomination || 0);
        const qty = Number(item?.qty || 0);
        const customerDis = Number(item?.customerDis || 0);
        const unitYouPay = +(denom * (1 - customerDis / 100)).toFixed(2); // per unit after discount
        // const linePrice = +(unitYouPay * qty).toFixed(2); // total for this line (you_pay * qty)
        return {
          item_brand: item?.name,
          item_name: item?.name,
          item_image: item?.image,
          affiliation: "IDFC Store",
          item_category: "giftcard",
          item_category2: OrderPayload?.category,
          // item_image: productReducer?.products?.[0]?.image,
          // value: linePrice,
          gift_card_points: denom,
          quantity: qty,
          price: unitYouPay,
          // unit_price: unitYouPay,
          item_id: item?.sku,
          item_url: window.location.href,
        };
      }),
    });

  };

  const replaceTermsAndConditions = (htmlTemplate, tncContent) => {
    let tncClean = tncContent?.replaceAll(/"/g, "'");
    let htmlStringData = htmlTemplate;
    if (tncContent) {
      htmlStringData = htmlStringData.replace("{#tncRemove}", "");
      htmlStringData = htmlStringData.replace("{/tncRemove}", "");
      let tnc = cleanHTML(tncClean);
      htmlStringData = htmlStringData.replace("{%tncContent%}", tnc);
    } else {
      htmlStringData = htmlStringData.replace(
        /{#tncRemove}[\s\S]*?{\/tncRemove}/,
        "",
      );
      htmlStringData = htmlStringData.replace("{#tncRemove}", "");
      htmlStringData = htmlStringData.replace("{/tncRemove}", "");
    }
    return htmlStringData;
  };

  const replaceImportantInstruction = (htmlTemplate, importantNote) => {
    let importantIns = importantNote?.replaceAll(/"/g, "'");
    let htmlStringData = htmlTemplate;
    if (importantIns) {
      htmlStringData = htmlStringData.replace("{#removeImportantIns}", "");
      htmlStringData = htmlStringData.replace("{/removeImportantIns}", "");
      let importantInstructions = cleanHTML(importantIns);
      htmlStringData = htmlStringData.replace(
        "{%importantInstructionsList%}",
        importantInstructions,
      );
    } else {
      htmlStringData = htmlStringData.replace(
        /{#removeImportantIns}[\s\S]*?{\/removeImportantIns}/,
        "",
      );
      htmlStringData = htmlStringData.replace("{#removeImportantIns}", "");
      htmlStringData = htmlStringData.replace("{/removeImportantIns}", "");
    }
    return htmlStringData;
  };

  const proccessOrderEmailTemplate = async (mailData) => {
    let template = cleanHTML(mailData?.mailBody);
    let templateChild = cleanHTML(mailData?.mailBodyChild);

    const lastName = loginV3Data?.memberProfile?.lastName;
    const firstName = loginV3Data?.memberProfile?.firstName;

    if (lastName === null || lastName === undefined) {
      template = template?.replace(
        "{%memberName%}",
        ` ${firstName}`
      );
    } else {
      template = template?.replace(
        "{%memberName%}",
        `${firstName} ${lastName}`,
      );
    }
    // template = template?.replace(
    //   "{%memberName%}",
    //   `${loginV3Data?.memberProfile?.firstName} ${loginV3Data?.memberProfile?.lastName}`,
    // );
    template = template?.replace(
      "{%orderId%}",
      orderData?.postOrderData?.[0]?.orderId,
    );
    const productImage =
      getImageUrl(productReducer?.productReducer?.small) ||
      "https://d16lf5hy7u28ft.cloudfront.net/ClientB/img/default.png";

    template = template?.replace("{%productUrl%}", productImage);
    template = template?.replace(
      "{%voucherName%}",
      productReducer?.productReducer?.name,
    );
    template = template?.replace("{%mobNo%}", clientConfig?.phoneNumber);

    template = replaceImportantInstruction(
      template,
      productReducer?.productReducer?.instructionsContent,
    );
    template = replaceTermsAndConditions(
      template,
      productReducer?.productReducerDisocount?.tncContent,
    );

    let childData = processignOrderEmailChile(templateChild);
    template = template?.replace("{%child%}", childData);
    return template;
  };

  const processignOrderEmailChile = (templateChild) => {
    let dynamicChild = templateChild;

    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, "0")}/${String(
      today.getMonth() + 1,
    ).padStart(2, "0")}/${today.getFullYear()}`;
    const { orderStatus, totalAmount } = orderData.updatedOrderData;
    dynamicChild = dynamicChild?.replace(
      "{%orderId%}",
      orderData?.postOrderData?.[0]?.orderId,
    );
    dynamicChild = dynamicChild?.replace("{%orderDate%}", formattedDate || "");
    dynamicChild = dynamicChild?.replace(
      "{%brand%}",
      productReducer?.productReducer?.name || "",
    );
    dynamicChild = dynamicChild?.replace("{%value%}", totalAmount || "");
    dynamicChild = dynamicChild?.replace("{%status%}", orderStatus || "");
    dynamicChild = dynamicChild.replace(/\\/g, "");
    return dynamicChild;
  };

  const fetchEmailTemplate = async (data, storedOrderDetails, payloadData) => {
    let template = cleanHTML(data?.mailBody);
    let templateChild = cleanHTML(data?.mailBodyChild);
    template = dynamicEmail(
      template,
      storedOrderDetails,
      payloadData,
      templateChild,
    );
    return template;
  };

  const dynamicEmail = (
    htmlString,
    storedOrderDetails,
    payloadData,
    templateChild,
  ) => {
    let htmlStringData = htmlString;
    const giftCode = vendorData?.vendorOrderData?.giftcode
      ? decryptAES(vendorData?.vendorOrderData?.giftcode)
      : null;
    const hasCardPin = giftCode?.some(
      (item) => item.CardPin !== null && item.CardPin !== "",
    );
    htmlStringData = dynamicSuccessEmailColumnChnages(
      htmlStringData,
      giftCode?.[0]?.labels?.cardNumber,
      hasCardPin,
    );

    htmlStringData = htmlStringData?.replace(
      "{%gcidLabel%}",
      giftCode?.[0]?.labels?.cardNumber,
    );
    htmlStringData = htmlStringData?.replace(
      "{%voucherCodeLabel%}",
      giftCode?.[0]?.labels?.cardPin,
    );

    if (!giftCode?.[0]?.labels?.cardNumber) {
      htmlStringData = htmlStringData?.replace(
        /{{#label}}[\s\S]*?{{\/label}}/,
        "",
      );
    } else {
      htmlStringData = htmlStringData
        ?.replace("{{#label}}", "")
        ?.replace("{{/label}}", "");
    }
    if (!hasCardPin) {
      htmlStringData = htmlStringData?.replace(/{{#pin}}[\s\S]*?{{\/pin}}/, "");
    } else {
      htmlStringData = htmlStringData
        ?.replace("{{#pin}}", "")
        ?.replace("{{/pin}}", "");
    }

    const lastName = loginV3Data?.memberProfile?.lastName;
    const firstName = loginV3Data?.memberProfile?.firstName;

    if (lastName === null || lastName === undefined) {
      htmlStringData = htmlStringData?.replace(
        "{%memberName%}",
        ` ${firstName}`
      );
    } else {
      htmlStringData = htmlStringData?.replace(
        "{%memberName%}",
        `${firstName} ${lastName}`,
      );
    }
    htmlStringData = htmlStringData?.replace(
      "{%orderId%}",
      orderData?.postOrderData?.[0]?.orderId,
    );

    const productImage =
      getImageUrl(productReducer?.productReducer?.small) ||
      "https://dpjvnq3sbpndh.cloudfront.net/email-images/fallbackimg_giftcard.png";

    htmlStringData = htmlStringData?.replace("{%productUrl%}", productImage);

    const productId = productReducer?.productReducer?.id?.toString();
    const finalProductId =
      process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? productId
        : encryptURLParam(productId);
    const finalOrderId = process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
      ? orderData?.postOrderData?.[0]?.orderId
      : encryptURLParam(orderData?.postOrderData?.[0]?.orderId);
    htmlStringData = htmlStringData?.replace(
      "{%redeemLink%}",
      `${window.location.origin}/tnc?productId=${finalProductId}&orderId=${finalOrderId}`,
    );

    htmlStringData = htmlStringData?.replace(
      "{%voucherName%}",
      productReducer?.productReducer?.name,
    );
    // Convenience Fee + GST combined value
    if (OrderPayload.convenienceFee && OrderPayload.gst) {
      htmlStringData = htmlStringData
        ?.replace("{{#ifShowGST}}", "")
        ?.replace("{{/ifShowGST}}", "");
      htmlStringData = htmlStringData?.replace(
        /{{#ifShow}}[\s\S]*?{{\/ifShow}}/,
        "",
      );
      const total = (convenienceFee + gst).toFixed(2);
      htmlStringData = htmlStringData?.replace("{%gstConv%}", total);
    } else if (OrderPayload.convenienceFee) {
      htmlStringData = htmlStringData
        ?.replace("{{#ifShow}}", "")
        ?.replace("{{/ifShow}}", "");
      htmlStringData = htmlStringData?.replace(
        /{{#ifShowGST}}[\s\S]*?{{\/ifShowGST}}/,
        "",
      );
      htmlStringData = htmlStringData?.replace(
        "{%gstConv%}",
        convenienceFee?.toFixed(2),
      );
    } else {
      htmlStringData = htmlStringData?.replace(
        /{{#ifShow}}[\s\S]*?{{\/ifShow}}/,
        "",
      );
      htmlStringData = htmlStringData?.replace(
        /{{#ifShowGST}}[\s\S]*?{{\/ifShowGST}}/,
        "",
      );
    }
    htmlStringData = htmlStringData?.replace(
      "{%cashPaid%}",
      OrderPayload.amount,
    );
    htmlStringData = htmlStringData?.replace(
      "{%ptsRedeem%}",
      OrderPayload?.totalBurn,
    );

    const totalvalue = totalPaid.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

    htmlStringData = htmlStringData?.replace("{%totalAmt%}", totalvalue);
    htmlStringData = (htmlStringData || "").replace(
      "{%TNC%}",
      cleanHTML(productReducer?.productReducer?.tncContent) || "",
    );
    htmlStringData = htmlStringData?.replace(
      "{%mobNo%}",
      clientConfig?.phoneNumber,
    );

    htmlStringData = replaceImportantInstruction(
      htmlStringData,
      productReducer?.productReducer?.instructionsContent,
    );
    htmlStringData = replaceTermsAndConditions(
      htmlStringData,
      productReducer?.productReducerDisocount?.tncContent,
    );

    let childData = dynamicChildEmail(
      payloadData,
      templateChild,
      storedOrderDetails,
      giftCode,
    );

    htmlStringData = htmlStringData?.replace("{%child%}", childData);
    return htmlStringData;
  };

  const dynamicChildEmail = (
    payloadData,
    templateChild,
    storedOrderDetails,
    giftCode,
  ) => {
    if (flow1) {
      let dynamicChild = templateChild;
      let dynamicChildData = "";
      giftCode?.map((item) => {
        dynamicChild = dynamicSuccessEmailColumnChnages(
          dynamicChild,
          item?.CardNumber,
          item?.CardPin || item?.CardPin !== "",
        );

        dynamicChildData += dynamicChild?.replace(
          "{%voucherValue%}",
          item.Amount.split(".")[0],
          //item.Amount
        );
        dynamicChildData = dynamicChildData?.replace(
          "{%gcidValue%}",
          item?.CardNumber || "",
        );
        dynamicChildData = dynamicChildData?.replace(
          "{%vouherCodeValue%}",
          item?.CardPin,
        );
        if (!item?.CardNumber) {
          dynamicChildData = dynamicChildData?.replace(
            /{{#label}}[\s\S]*?{{\/label}}/,
            "",
          );
        } else {
          dynamicChildData = dynamicChildData
            ?.replace("{{#label}}", "")
            ?.replace("{{/label}}", "");
        }
        if (!item?.CardPin || item?.CardPin === "") {
          dynamicChildData = dynamicChildData?.replace(
            /{{#pin}}[\s\S]*?{{\/pin}}/,
            "",
          );
        } else {
          dynamicChildData = dynamicChildData
            ?.replace("{{#pin}}", "")
            ?.replace("{{/pin}}", "");
        }
        dynamicChildData = dynamicChildData?.replace(
          "{%expiryDate%}",
          new Date(item?.Validity).toLocaleDateString("en-GB"),
        );
      });
      return dynamicChildData;
    } else if (flow2) {
      let dynamicChild = templateChild;
      let dynamicChildData = "";
      OrderPayload?.products?.map((item) => {
        dynamicChildData += dynamicChild?.replace("{%qty%}", item.qty);
        dynamicChildData = dynamicChildData?.replace(
          "{%denomination%}",
          item.denomination,
        );
        dynamicChildData = dynamicChildData?.replace(
          "{%voucherValue%}",
          Number(item.denomination * item.qty * (1 - item.customerDis / 100)),
        );
        var enc = encryptAES(
          `email=true&orderId=${orderData?.postOrderData?.[0]?.orderId}&denomination=${item.denomination}&orderNumber=${orderData?.postOrderData?.[0]?.orderNumber}&mobNumber=${loginTokenData?.mobileNumber}&fName=${loginTokenData?.firstName}&lName=${loginTokenData?.lastName}`,
        );
        dynamicChildData = dynamicChildData?.replace(
          "{%retrieveCode%}",
          `${window.location.origin}/${clientConfig?.otpRedeem ? "otp" : "order-detail"
          }?${enc}`,
        );
      });
      return dynamicChildData;
    }
  };

  const replacePlaceholders = (template, replacements) => {
    return template?.replace(/{{(.*?)}}/g, (_, key) => replacements[key]);
  };

  function getEmailTemplateByType(emailType) {
    return (
      emailData.find(
        (template) =>
          template.emailType === emailType &&
          template.enabled &&
          template.eventType.toLowerCase() === "email".toLowerCase(),
      ) || null
    );
  }

  function getSMSTemplateByType(emailType) {
    return (
      emailData.find(
        (template) =>
          template.emailType.toLowerCase() === "success".toLowerCase() &&
          template.enabled &&
          template.eventType.toLowerCase() === "sms",
      ) || null
    );
  }

  const sendMail = async () => {
    setOrderJourneyStarted(true);
    axiosIntegration.defaults.headers["access-token"] =
      `${generateToken?.data?.accessToken}`;
    axiosIntegration.defaults.headers["ClientCode"] = `${v3Data.ClientCode}`;
    axiosIntegration.defaults.headers["PartnerCode"] = `${v3Data.partnerCode}`;
    let emailType = "Success";
    if (vendorData?.postMessage?.toLowerCase() === "Processing".toLowerCase()) {
      emailType = "Processing";
    }
    const activeEmail = getEmailTemplateByType(emailType);
    const status = (vendorData?.postMessage || "").trim().toLowerCase();
    const template =
      status !== "processing"
        ? await fetchEmailTemplate(activeEmail, OrderPayload)
        : await proccessOrderEmailTemplate(activeEmail);

    let subject = activeEmail?.subject;
    subject = subject?.replace(
      "{%voucherName%}",
      productReducer?.productReducer?.name,
    );

    let htmlContent = replacePlaceholders(template, {});
    htmlContent = htmlContent?.replace(/\\r\\n|\\n|\\r/g, "");
    htmlContent = htmlContent.replaceAll("\\", "");
    // htmlContent = htmlContent?.replace(/\\"/g, '"');

    const payload = {
      toEmailId: loginV3Data?.memberProfile?.emailId,
      templateCode: activeEmail?.tempCode,
      content: htmlContent,
      subject: subject,
      contentValue: {
        UserName: "",
      },
    };
    try {
      dispatch(onPostSendMail(payload));
      if (status === "processing") {
        handleProcessingSms(
          dispatch,
          sendMailData,
          v3Data,
          loginV3Data,
          orderData?.postOrderData?.[0]?.orderId,
          OrderPayload,
        );
      }
    } catch (error) {
    } finally {
    }
  };

  // useEffect(() => {

  //   debugger
  //   // if (switchAccountData?.creditCards?.length > 0) {
  //   //   dispatch(
  //   //     onSavePoints({
  //   //       points: Math.round(
  //   //         memberData?.MemberData?.memberBalance?.[0]?.pointBalance
  //   //       ),
  //   //       identifierType: "1001",
  //   //       subIdentifier: "0",
  //   //     })
  //   //   )
  //   // }
  // }, [switchAccountData]);
  useEffect(() => {
    document.body.classList.add("checkout-page-active");
    return () => {
      document.body.classList.remove("checkout-page-active");
    };
  }, []);
  return (
    <div className="checkout-page-active">
      <ToastContainer />
      <div className="mt-3 checkout-page">
        <div className="bg-white rightCart bnb bnb1 padding-0">
          {/* <div className="d-flex justify-content-between jlkkedit p-4 pt-2 pb-2  mb-2">
            <div className="user-cart">{translation?.userDetails}</div>
          </div>

          <div className="info p-3 pt-0 pb-1">
            <div className="d-flex justify-content-start align-items-center jlkk">
              <div className="mr-4 cartnamefirst">{translation?.nameLabel}</div>
              <div className="cartnamesecond">
                {loginV3Data?.memberProfile?.firstName}{" "}
                {loginV3Data?.memberProfile?.lastName}
              </div>
            </div>
            <div className="d-flex justify-content-start align-items-center jlkk">
              <div className="mr-4 cartnamefirst">{translation?.mobileNo}.</div>
              <div className="cartnamesecond">
                {loginV3Data?.memberProfile?.mobileNumber}
              </div>
            </div>
            <div className="d-flex justify-content-start jlkk">
              <div className="mr-4 cartnamefirst">{translation?.email}</div>
              <div className="cartnamesecond text-break">
                {loginV3Data?.memberProfile?.emailId}
              </div>
            </div>
          </div> */}
          {/* 👇 Collapsible User Details — same UI look */}
          <div
            className={`d-flex justify-content-between align-items-center${openUser || !isUserAccrodianCollapsed
              ? "jlkkedit2 editborder pt-2 pb-2 mb-2"
              : "jlkkedit2 pt-2 pb-2"
              } `}
            onClick={() => setOpenUser(!openUser)}
            style={{ cursor: "pointer" }}
          >
            <div className="user-cart jlkkedit2">
              {translation?.userDetails}
            </div>
            {isUserAccrodianCollapsed && (
              <div className="arrow arrowPad">
                <i
                  className={`fa-solid ${openUser ? "fa-angle-up" : "fa-angle-down"
                    }`}
                ></i>
              </div>
            )}
          </div>

          {(openUser || !isUserAccrodianCollapsed) && (
            <div className="info pt-0 pb-1">
              <div className="d-flex justify-content-start align-items-center jlkkedit2">
                <div className="mr-4 cartnamefirst">
                  {translation?.nameLabel}
                </div>
                <div className="cartnamesecond">
                  {loginV3Data?.memberProfile?.firstName}{" "}
                  {loginV3Data?.memberProfile?.lastName}
                </div>
              </div>
              <div className="d-flex justify-content-start align-items-center jlkkedit2">
                <div className="mr-4 cartnamefirst">
                  {translation?.mobileNo}.
                </div>
                <div className="cartnamesecond">
                  {loginV3Data?.memberProfile?.mobileNumber}
                </div>
              </div>
              <div className="d-flex justify-content-start jlkkedit2">
                <div className="mr-4 cartnamefirst">{translation?.email}</div>
                <div className="cartnamesecond text-break">
                  {loginV3Data?.memberProfile?.emailId}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="tnc_redeem_note_box mt-3 jlkkedit2">
          <div
            className="item py-3"
            onClick={() => setOpenInst(!openInst)}
            style={{ cursor: "pointer" }}
          >
            <div className="text .jlkkedit2">
              {translation?.importantInstructions}
            </div>
            <div className="arrow">
              <i
                className={`fa-solid ${openInst ? "fa-angle-down" : "fa-angle-right"
                  }`}
              ></i>
            </div>
          </div>
          {openInst && (
            <div
              className="mt-2 mx-2 pd-left"
              style={{
                overflowWrap: "break-word",
              }}
              dangerouslySetInnerHTML={{
                __html:
                  productReducer?.productReducerDisocount
                    ?.instructionsContent || "",
              }}
            ></div>
          )}
          <div
            className="item py-3"
            onClick={() => setOpenRedeem(!openRedeem)}
            style={{ cursor: "pointer" }}
          >
            <div className="text">{translation?.how_to_use}</div>
            <div className="arrow " onClick={() => setOpenRedeem(!openRedeem)}>
              <i
                className={`fa-solid ${openRedeem ? "fa-angle-down" : "fa-angle-right"
                  }`}
              ></i>
            </div>
          </div>
          {openRedeem && (
            <div
              className="mt-2 mx-2 pd-left"
              style={{
                overflowWrap: "break-word",
              }}
              dangerouslySetInnerHTML={{
                __html:
                  productReducer.productReducerDisocount?.howToUseContent || "",
              }}
            ></div>
          )}
          <div
            className="item py-3"
            onClick={() => setOpenTermsCon(!openTermsCon)}
            style={{ cursor: "pointer" }}
          >
            <div className="text">{translation?.terms_condition}</div>
            <div
              className="arrow"
              onClick={() => setOpenTermsCon(!openTermsCon)}
            >
              <i
                className={`fa-solid ${openTermsCon ? "fa-angle-down" : "fa-angle-right"
                  }`}
              ></i>
            </div>
          </div>
          {openTermsCon && (
            <div
              className="mt-2 mx-2 pd-left"
              style={{
                overflowWrap: "break-word",
              }}
              dangerouslySetInnerHTML={{
                __html:
                  productReducer.productReducerDisocount?.tncContent || "",
              }}
            ></div>
          )}
          <div
            className="item py-3"
            onClick={() => setOpenNote(!openNote)}
            style={{ cursor: "pointer" }}
          >
            <div className="text">{translation?.note}</div>
            <div className="arrow" onClick={() => setOpenNote(!openNote)}>
              <i
                className={`fa-solid ${openNote ? "fa-angle-down" : "fa-angle-right"
                  }`}
              ></i>
            </div>
          </div>
          {openNote && (
            <div className="mt-2 mx-2 d-flex pd-left">
              <span className="checkterm1">{translation?.demoBomText}</span>
            </div>
          )}
        </div>
        <div className="mobile-sticky-footer">
          <div className="col-lg-12 col-12 mt-4 text-center mb-4">
            <button
              className="col-lg-12 col-12 clr-white buy-detailcart buy-now"
              disabled={allZero(quantities) || disabled}
              onClick={handleSubmit}
            >
              {translation?.buyNow} {!allZero(quantities) && translation.with}{" "}
              {!allZero(quantities) &&
                (points > 0 ? (
                  <>
                    {points} {translation?.pts}
                    {cash > 0 && <> + ₹{formatPrice(cash)}</>}
                  </>
                ) : (
                  <>₹ {formatPrice(totalPayableAmount)}</>
                ))}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
